var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcServicio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_157_31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.4917,
    cy: 47.0788,
    r: 38.4324,
    fill: "#00A552"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.4917,
    cy: 47.0788,
    r: 40.8344,
    stroke: "white",
    strokeWidth: 4.80405
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.4722 49.9819L58.8718 43.5824L42.9973 27.7305C41.3043 29.43 40.3538 31.7312 40.3538 34.13C40.3538 36.5289 41.3043 38.8301 42.9973 40.5296L52.4722 49.9819ZM67.804 45.8889C71.2639 47.4945 76.1257 46.3638 79.7212 42.7683C84.0403 38.4492 84.877 32.2531 81.5529 28.929C78.2514 25.6275 72.0553 26.4415 67.7136 30.7607C64.1181 34.3562 62.9874 39.218 64.5929 42.6779L42.5224 64.7484L45.7109 67.9369L61.2914 52.4016L76.8493 67.9595L80.0378 64.771L64.4799 49.2131L67.804 45.8889Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_157_31",
    x: -0.00000143051,
    y: -0.000463486,
    width: 113.375,
    height: 113.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.80405,
    dy: 9.60809
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.72566
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_157_31"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_157_31",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcServicio);
export default __webpack_public_path__ + "static/media/ic_servicio.642998f8ba8916d8f5ac09fce66fe938.svg";
export { ForwardRef as ReactComponent };